<template>
  <div>
    <!-- <h4 class="mt-5">isStatusInTraffic</h4> -->

    <!-- ArrivalDateAtDestination -->
    <b-form-group
      label="Data de chegada ao destino"
      label-for="ArrivalDateAtDestination"
    >
      <b-form-input
        id="ArrivalDateAtDestination"
        type="date"
        placeholder="Data de chegada ao destino"
        v-model="model.arrivalDateAtDestination"
        :readonly="readonly"
      />
      <span class="text-danger" v-if="modelstate['ArrivalDateAtDestination']">
        {{ modelstate["ArrivalDateAtDestination"][0] }}
      </span>
    </b-form-group>
    <!-- ArrivalHourAtDestination -->
    <b-form-group
      label="Hora de chegada ao destino"
      label-for="ArrivalHourAtDestination"
    >
      <b-form-input
        id="ArrivalHourAtDestination"
        type="time"
        placeholder="Hora de chegada ao destino"
        v-model="model.arrivalHourAtDestination"
        :readonly="readonly"
      />
      <span class="text-danger" v-if="modelstate['ArrivalHourAtDestination']">
        {{ modelstate["ArrivalHourAtDestination"][0] }}
      </span>
    </b-form-group>
    <!-- <cargo-occurrence-attachments
        :model="model"
        :readonly="readonly"
        :occurrence-type-id="8"
    >
    </cargo-occurrence-attachments> -->
  </div>
</template>

<script>
import AwesomeMask from "awesome-mask";
// import CargoOccurrenceAttachments from "@/components_rms/tracking/cargo/CargoOccurrenceAttachments.vue";

export default {
  name: "CargoCrudData",
  components: {
    // CargoOccurrenceAttachments,
  },
  directives: {
    mask: AwesomeMask,
  },
  props: {
    model: Object,
    modelstate: Object,
    readonly: Boolean,
  },
};
</script>
